import { ProfileListContent } from 'ui/components/ProfileListContent'

export const Favorites = () => <ProfileListContent isFavorites />
